
<template>
    <div class="center">
        <vs-row v-if="cards">
            <vs-col  v-if="cards.total_alumnos" sm="12" lg="3" class="p-1">
                <div class="card md-warn">
                    <div class="card-body text-center">
                        <h4 class="mb-0"><strong>{{cards.total_alumnos}}</strong></h4>
                        <p class="mb-0"><strong>Total</strong></p>
                    </div>
                </div>
            </vs-col>
            <vs-col sm="12" lg="3" class="p-1" v-for="(carta, key) in cards.status" :key="key">
                <div class="card md-blue">
                    <div class="card-body text-center">
                        <h4 class="mb-0"><strong>{{carta}}</strong></h4>
                        <p class="mb-0"><strong>{{key}}</strong></p>
                        <p class="mb-0"><small>Estatus</small></p>
                    </div>
                </div>
            </vs-col>
            <vs-col sm="12" lg="3" class="p-1" v-for="(carta, key) in cards.oferta_academica" :key="key">
                <div class="card md-green">
                    <div class="card-body text-center">
                        <h4 class="mb-0"><strong>{{carta}}</strong></h4>
                        <p class="mb-0"><strong>{{key}}</strong></p>
                        <p class="mb-0"><small>Oferta académica</small></p>
                    </div>
                </div>
            </vs-col>
        </vs-row>
        <vs-row>
            <vs-col w="12" style="margin-top: 23px; display: flex">
                <vs-button
                    class="ml-auto"
                    success
                    :loading="loadingExcel"
                    @click="getFileProspectos()"
                >
                    Descargar excel
                </vs-button>
            </vs-col>
            <vs-col sm="12" lg="3" class="ml-auto">
                <vs-input v-model="search" placeholder="Buscar">
                    <template #icon>
                        <i class="fas fa-search"></i>
                    </template>
                </vs-input>
            </vs-col>
        </vs-row>
        <vs-table striped>
            <template #thead>
                <vs-tr>
                    <vs-th style="width: 30px !important;">
                        ID
                    </vs-th>
                    <vs-th>
                        Prospecto
                    </vs-th>
                    <vs-th>
                        Escuela procedencia
                    </vs-th>
                    <vs-th>
                        Oferta Academica
                    </vs-th>
                    <vs-th>
                        Familiares
                    </vs-th>
                    <vs-th>
                        Grupo
                    </vs-th>
                    <vs-th>
                        Pagos
                    </vs-th>
                    <vs-th></vs-th>
                </vs-tr>
            </template>
            <template #tbody>
                <vs-tr
                    :key="i"
                    v-for="(tr, i) in $vs.getSearch(users, search)"
                    :data="tr"
                    style="border-bottom: 1px solid #D7DBDD;"
                >
                    <vs-td>
                        {{ tr.proceso_admision.prospecto_id }}
                    </vs-td>
                    <vs-td>
                        {{ tr.fullName }}
                    </vs-td>
                    <vs-td>
                        <div v-if="tr && tr.proceso_admision && tr.proceso_admision.escuela_procedencia">
                            <p class="mb-0">{{ tr.proceso_admision.escuela_procedencia.nombre }} </p>
                            <p class="mb-0"><small>Ubicación</small></p>
                            <p class="mb-0">{{ tr.proceso_admision.escuela_procedencia.ciudad }}, {{ tr.proceso_admision.escuela_procedencia.estado }}</p>
                        </div>
                    </vs-td>
                    <vs-td>
                        <p class="mb-0 text-center">{{ tr.oferta_academica }}</p>
                        <hr class="m-0">
                        <p class="mb-0 text-center">{{tr.proceso_admision.status.status}}</p>
                    </vs-td>
                    <vs-td>
                        <div v-for="(fam, i) in tr.familiares" :key="i">
                            <p class="mb-0">{{fam.nombre}}</p>
                            <p class="mb-0"><i class="far fa-envelope"></i> {{fam.correo}}</p>
                            <p class="mb-0"><i class="fas fa-phone"></i> {{fam.telefono}}</p>
                            <hr v-if="tr.familiares[1]" class="m-0">
                        </div>
                    </vs-td>
                    <vs-td>
                        <div v-for="(group, i) in tr.grupos" :key="i">
                            <md-chip class="mini-chip col-blue" ><strong> {{ group }} </strong></md-chip>
                        </div>
                    </vs-td>
                    <vs-td>
                        <p v-if="tr.pagos" class="mb-0">{{tr.pagos}}</p>
                    </vs-td>
                    <vs-td>
                        
                        <md-menu md-size="small" md-align-trigger>
                            <md-button md-menu-trigger><i class="fas fa-ellipsis-v"></i></md-button>

                            <md-menu-content>
                                <md-menu-item :href="'/panel/seguimiento/'+window.btoa(tr.id)+'/institucion/'+window.btoa(tr.proceso_admision.oferta_academica.institucion_id)" target="_blank">Ir a perfil</md-menu-item>
                            </md-menu-content>
                        </md-menu>
                    </vs-td>
                </vs-tr>
            </template>
            <template #notFound>
                Sin información
            </template>
      </vs-table>
    </div>
</template>
<script>
    export default {
        props: [
            'users',
            'cards',
            'headers'
        ],
        data:() => ({
            search: '',
            estatusColor: {
                'Prospecto': {
                    'color': 'purple'
                },
                'Interesado': {
                    'color': 'brown'
                },
                'Aplicante': {
                    'color': 'blue'
                },
                'Admitido': {
                    'color': 'green'
                },
                'Inscrito económico': {
                    'color': 'blue'
                },
                'Congelado': {
                    'color': 'pink'
                },
                'Descartado': {
                    'color': 'pink'
                },
                'Inscrito académico': {
                    'color': 'yellow'
                },
                'Acreditado en ciclo escolar': {
                    'color': 'green'
                },
                'No acreditado en ciclo escolar': {
                    'color': 'pink'
                },
                'Baja definitiva voluntaria': {
                    'color': 'gray'
                },
                'Baja definitiva por conducta': {
                    'color': 'gray'
                },
                'Baja temporal voluntaria': {
                    'color': 'gray'
                },
                'Suspensión por morosidad': {
                    'color': 'red'
                },
                'Bloqueo para inscripción': {
                    'color': 'red'
                },
                'Reactivación': {
                    'color': 'blue'
                },
            },
            loadingExcel: false
        }),
        methods: {
            async getFileProspectos(){
                this.loadingExcel = true
                setTimeout(() => {
                    axios.get('/reportes/file-prospectos', {
                        responseType: 'blob',
                        params: {...this.headers},
                        // responseType: 'arraybuffer',
                    }).then(response => {
                        this.loadingExcel = false
                        if (response.data instanceof Blob) {
                            const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
                            const link = document.createElement('a');
                            link.href = downloadUrl;
                            var filename = "";
                            const disposition = response.headers['content-disposition'];
                            if (disposition && disposition.indexOf('attachment') !== -1) {
                                const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                                const matches = filenameRegex.exec(disposition);
                                if (matches != null && matches[1]) {
                                    filename = matches[1].replace(/['"]/g, '');
                                    link.setAttribute('download', filename)
                                }
                            }
                            document.body.appendChild(link);
                            link.click();
                            link.remove();
                        }else{
                            throw { message: 'formatError' }
                        }
                        this.$vs.notification({
                            progress: 'auto',
                            color: 'success',
                            position: 'bottom-right',
                            title: 'Éxito',
                            text: 'Descarga lista'
                        })
                        this.loadingExcel = false
                    }).catch(e => {
                        this.loadingExcel = false
                        this.$vs.notification({
                            progress: 'auto',
                            color: 'danger',
                            position: 'bottom-right',
                            title: 'Ocurrió un problema inesperado'
                        })
                    });
                }, 500);
            },
        }
    }
</script>

<style scoped>
    .col-yellow{
        background: rgb(255, 248, 236);
        color: #febf3d;
    }

    .col-red{
        color: #f62d51;
        background: rgb(249, 231, 235);
    }

    .col-green{
        color: #55ce63;
        background: rgb(232, 253, 235);
    }

    .col-purple{
        color: purple;
        background: rgb(232, 218, 239);
    }

    .col-blue{
        color: #2874A6;
        background: rgb(214, 234, 248);
    }

    .col-gray{
        color: #5F6A6A;
        background: rgb(242, 243, 244);
    }

    .col-pink{
        color: #F08080;
        background: rgb(255, 236, 236);
    }

    .col-brown{
        color: #784212;
        background: rgb(250, 229, 211);
    }
    

    .md-warn{
        background: #ffbc34;
        color: white;
        border-radius: 7px;
    }

    .md-blue{
        background: #5DADE2;
        color: white;
        border-radius: 7px;
    }

    .md-green{
        background: #52BE80;
        color: white;
        border-radius: 7px;
    }
</style>

        